import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/business-service/admin/admin.service';

@Component({
  selector: 'app-aws-redirection',
  templateUrl: './aws-redirection.component.html',
  styleUrls: ['./aws-redirection.component.scss'],
})
export class AwsRedirectionComponent implements OnInit {
  checkStatus: boolean = true;
  showSpinner: boolean = false;

  constructor(private adminService: AdminService,
    private router: Router
  ) { }

  ngOnInit() {
    this.showSpinner = true;

    this.adminService.initiateSenderEmailUpdate().subscribe({
      next: (data: any) => {
        this.checkStatus = true;
      },
      error: (error) => {
        this.checkStatus = false;
      },
      complete: () => {
        this.showSpinner = false
      }
    });
  }

  gotoLogin() {
    this.router.navigate(["/login"]);
  }
}
